import { CaretDownOutlined } from "@ant-design/icons";

export const GroupAccordionSection = ({
  title,
  total,
  expanded,
  onToggle,
  sectionId,
  children,
}) => {
  return (
    <div className="group-section" data-testid={sectionId ? `${sectionId}-section` : undefined}>
      <div
        className="group-section-header"
        onClick={onToggle}
        data-testid={sectionId ? `${sectionId}-header` : undefined}
      >
        <span>{title}</span>

        <div className="group-section-right">
          <span className="group-count" data-testid={sectionId ? `${sectionId}-total` : undefined}>{total}</span>
          <CaretDownOutlined
            className={expanded ? "rotated" : ""}
          />
        </div>
      </div>

      {expanded && (
        <div className="group-section-content" data-testid={sectionId ? `${sectionId}-content` : undefined}>
          {children}
        </div>
      )}
    </div>
  );
};